/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import { propTypesLink, propTypesTextHtml } from '../../../constants/Proptypes';

export const propTypesFooter = {
  data: PropTypes.shape({
    description: PropTypes.shape(propTypesTextHtml),
    social_networks: PropTypes.arrayOf(
      PropTypes.shape({
        social_link: PropTypes.shape(propTypesLink),
        social_name: PropTypes.string,
        obfuscate: PropTypes.string,
      })
    ),
    open_cookie_label: PropTypes.string,
  }),
  lang: PropTypes.string,
  type: PropTypes.string,
};
